export const OPEN_ID_CONNECT_CURRENT_JOURNEY_KEY = "currentJourney"; // has to match with the one in open-id-connect.const.ts
